import { createApp } from 'vue';
import { KAlert, KButton, KCaption, KLink } from 'kt-vuecomponents';
import { KtVueComponents } from 'kt-vuecomponents';
import 'kt-vuecomponents/kt-vuecomponents.css';
import KLanguageEnforcer from '@aml/common/src/components/KLanguageEnforcer.vue';
import { options } from '@aml/common/src/libraries/kt-vuecomponents';
import '@aml/common/src/common/validations';
import './src/styles/site.scss';

/*
------------------------------------------------------
------------------------------------------------------
TÄNNE KILLAN KIRJAUTUMISSIVUILLA TARVITTAVAT KOMPONENTIT
------------------------------------------------------
------------------------------------------------------
*/

const app = createApp({
  components: {
    KLink,
    KAlert,
    KButton,
    KLanguageEnforcer,
    KCaption,
  },
});

app.use(KtVueComponents, options);

const k = window as any;
k.vueApp = app.mount('#app');
